// my-loader.component.ts
import { ChangeDetectorRef, Component, DestroyRef, NgZone, OnInit, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoaderService } from '../../services/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    imports: [NgIf]
})
export class LoaderComponent implements OnInit {
    private destroyRef = inject(DestroyRef);
    loading = false;

    constructor(
        private loaderService: LoaderService,
        private cdr: ChangeDetectorRef,
        private ngZone: NgZone
    ) {
    }

    ngOnInit(): void {
        this.loaderService.isLoading.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((v) => {
            this.ngZone.run(() => {
                this.loading = v;
                this.cdr.detectChanges();
            });
        });
    }
}
